import {
    GET_CYLINDER_STATUS_LIST_PROGRESS, GET_CYLINDER_STATUS_LIST_SUCCESS, GET_CYLINDER_STATUS_LIST_FAILURE,
    ADD_CYLINDER_STATUS_PROGRESS, ADD_CYLINDER_STATUS_SUCCESS, ADD_CYLINDER_STATUS_FAILURE,
    EDIT_DELETE_CYLINDER_STATUS_PROGRESS, EDIT_DELETE_CYLINDER_STATUS_SUCCESS, EDIT_DELETE_CYLINDER_STATUS_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    custType: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const cylinder_status_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CYLINDER_STATUS_LIST_SUCCESS:
            return { ...state, cylinder_status: action.cylinder_status, loading: false };
        case GET_CYLINDER_STATUS_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CYLINDER_STATUS_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CYLINDER_STATUS_PROGRESS:
            return { ...state, loading: true };
        case ADD_CYLINDER_STATUS_SUCCESS:
            return { ...state, cylinder_status: [...state.cylinder_status, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CYLINDER_STATUS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CYLINDER_STATUS_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CYLINDER_STATUS_SUCCESS:
            return {
                ...state,
                cylinder_status: state.cylinder_status.map((cylinder_status) =>
                    cylinder_status.id === action.payload.id ? action.payload : cylinder_status
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CYLINDER_STATUS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default cylinder_status_reducer;